import IcAssistance from './IcAssistance'
export default IcAssistance
